import "./Aboutus.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import React, { useEffect, useState } from "react";
import Basic from "../components/Basic";
import Footer from "../components/Footer";
import Slide from "@mui/material/Slide";
import axios from "axios";
//import Imageslide from "./Imageslide";
import { Pagination } from "react-bootstrap";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { FaAngleUp } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import { useLocation } from "react-router-dom";
import { TransitionProps } from "@mui/material/transitions";
import "./Gallery.css";

function Gallery(props) {
  const [currentPage, setCurrentPage] = useState(1);
  const [plantsPerPage] = useState(30);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [Plants, setPlants] = useState([]);
  const location = useLocation();

  useEffect(() => {
    axios
      .get("https://server-zqk9.onrender.com/Home")
      .then((response) => {
        setPlants(response.data);
      })
      .catch((err) => console.log(err));

    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const scrollThreshold = -1;

      if (scrollPosition > scrollThreshold) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Scroll to top when the component mounts or location changes
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastPlant = currentPage * plantsPerPage;
  const indexOfFirstPlant = indexOfLastPlant - plantsPerPage;
  const currentPlants = Plants.slice(indexOfFirstPlant, indexOfLastPlant);

  return (
    <>
      <Basic />

      <div className="Sections">
        <div className="col-md-15 main">
          <h1 style={{ color: "#179f3e", textAlign: "center" }}>
            Plants Gallery
          </h1>
        </div>
        {/* <div className="col-md-6 d-flex justify-content-end">
          <div className="search-bar-container">
            <input
              type="text"
              className="search-bar-input"
              placeholder="Search by name/uses/category"
            />
            <button
              type="button"
              style={{
                border: "none",
                backgroundColor: "transparent",
                cursor: "pointer",
                marginRight: "50px",
              }}
            ></button>
          </div>
        </div> */}

        <div
          className="Gallerycontainer"
          style={{ marginRight: "3%", marginLeft: "2%" }}
        >
          <div className="row">
            {currentPlants.map((plant, index) => (
              <div
                className="col-md-2 py-1 d-flex justify-content-cemter"
                key={index}
              >
                <img
                  src={`${plant?.image?.images}`}
                  style={{ maxWidth: "100%" }}
                  alt=""
                />
                {/* {props?.english} ({props?.plantInfo?.scientific_name}) */}
              </div>
            ))}
          </div>
          <div className="pagination-container d-flex justify-content-center mt-3 display-2">
            <Pagination>
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => paginate(currentPage - 1)}
              >
                <FaAngleLeft />
              </Pagination.Prev>

              {Array.from({
                length: Math.ceil(Plants.length / plantsPerPage),
              }).map((_, index) => {
                if (
                  (currentPage <= 2 && index < 3) ||
                  (currentPage > 2 &&
                    index >= currentPage - 2 &&
                    index <= currentPage)
                ) {
                  return (
                    <Pagination.Item
                      key={index}
                      active={index + 1 === currentPage}
                      onClick={() => paginate(index + 1)}
                    >
                      {index + 1}
                    </Pagination.Item>
                  );
                }
                return null;
              })}

              <Pagination.Next
                disabled={
                  currentPage === Math.ceil(Plants.length / plantsPerPage)
                }
                onClick={() => paginate(currentPage + 1)}
              >
                <FaAngleRight />
              </Pagination.Next>
            </Pagination>
          </div>
        </div>

        {showScrollButton && (
          <Tooltip title="Scroll up">
            <button className="back-to-top" onClick={scrollToTop}>
              <FaAngleUp />
            </button>
          </Tooltip>
        )}
      </div>
      {/* <div className="image_container">
        <div className="image">
          <Imageslide />
        </div>
      </div> */}
      <Footer />
    </>
  );
}

export default Gallery;
